module.exports = __webpack_public_path__ + "img/hexagon-multiple.ffe7dd40.svg";